import { makeStyles } from 'tss-react/mui';

const name = 'Avatar';

export const useAvatarStyles = makeStyles<string>({ name })(
  (theme, avatarColor) => ({
    root: {
      width: 32,
      height: 32,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      backgroundColor: avatarColor,
    },
    avatarTitle: {
      textTransform: 'uppercase',
      fontWeight: 500,

      [theme.breakpoints.down('xs')]: {
        fontSize: 9,
      },
    },
  }),
);
